module.exports = __webpack_public_path__ + "static/media/diaper260-280.f5e0faa1.png";